import ajax from 'Site/js/util/ajax.fetch';
import analytics from 'Site/js/util/analytics';
import AutoComplete from 'Site/component/AutoComplete.vue';
import Comments from 'Feedback/component/Comments.vue';
import CompactUser from 'Profile/component/CompactUser.vue';
import collapseDirective from 'Site/directive/collapse';
import dropdownDirective from 'Site/directive/dropdown';
import Ebook from 'Stories/component/Ebook.vue';
import 'vue-awesome/icons/share-alt';
import Form from 'Site/js/util/form';
import Modal from 'Site/component/Modal.vue';
import Media from 'Media/component/Media.vue';
import MediaPicker from 'Media/component/MediaPicker.vue';
import { mapState } from 'vuex';
import PaginationValidation from 'Site/js/mixin/pagination.input.check';
import PromptSignup from 'Site/js/mixin/prompt.signup';
import random from 'Site/js/util/random';
import SiteInput from 'Site/component/SiteInput.vue';
import SiteTextArea from 'Site/component/SiteTextArea.vue';
import SiteSelect from 'Site/component/SiteSelect.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import storyListMixin from '../mixin/story.list';

function stories() {
    new Vue({ /* eslint no-new: 0 */
        el: '#stories-body',
        name: 'stories',
        store,
        components: {
            SiteInput,
            SiteSelect
        },
        computed: {
            ...mapState(['isMobile', 't']),
        },
        data() {
            return {
                showSearchForm: !store.state.isMobile,
            };
        },
        directives: {
            collapse: collapseDirective,
            dropdown: dropdownDirective
        },
        methods: {
            bannerBackground() {
                const base = this.$store.state.config.data.bannerUrl;
                const number = random(1, 6);
                const positions = [
                    'right',
                    '-600px',
                    '-700px',
                    '-140px',
                    '-580px',
                    '-800px'
                ];
                let background = `background-image: url(${base}join-${number}.jpg);`;
                if (this.isMobile) {
                    background += `background-position-x: ${positions[number - 1]};`;
                }
                return background;
            },
            joinButton() {
                this.showJoin();
            },
            showJoin() {
                this.$store.dispatch('showJoin');
            }
        },
        mixins: [PaginationValidation, storyListMixin]
    });
}

function storiesForm() {
    new Vue({ /* eslint no-new: 0 */
        el: '#vue-story-form',
        name: 'storiesSubmit',
        store,
        components: {
            AutoComplete,
            Media,
            MediaPicker,
            Modal,
            SiteInput,
            SiteSelect,
            SiteTextArea
        },
        computed: {
            wordCount() {
                if (!this.form.story) {
                    return 0;
                }
                return this.form.story.trim().replace(/\s+/gi, ' ').split(' ').length;
            }
        },
        data() {
            const { data } = store.state.config;
            let tagList = data.tags;

            if (data.tags && !Array.isArray(data.tags)) {
                tagList = [];
                data.tags.split(',').forEach((tag) => {
                    tagList.push({ value: tag, name: tag });
                });
            }
            return {
                form: new Form({
                    title: data.title,
                    oneLiner: data.oneLiner,
                    genre: data.genre,
                    story: data.story,
                }, {
                    title: [{ type: 'required' }, { type: 'max', value: 500 }],
                    genre: ['required'],
                    story: ['required'],
                    oneLiner: [{ type: 'max', value: 200 }]
                }),
                displayName: data.displayName,
                initialTags: tagList || [],
                hiddenAuthor: data.hiddenAuthor,
                previousStory: data.previousStory,
                media: data.media,
                nextStory: data.nextStory,
                showMediaPicker: false,
                tags: tagList ? tagList.map(tag => tag.value) : [],
                tagOptions: data.tagOptions
            };
        },
        mounted() {
            const $form = document.querySelector('#story-form');
            $form.addEventListener('submit', this.submit);
            $form.addEventListener('keydown', this.validate);
        },
        methods: {
            validate(e) {
                let field = null;
                if (e) {
                    field = e.srcElement.name;
                }
                this.form.errors.clear(field);
                this.form.validate(field);
            },
            setMedia([media]) {
                this.showMediaPicker = false;
                this.media = media;
            },
            submit(e) {
                e.preventDefault();
                if (this.form.validate()) {
                    const $form = document.querySelector('#story-form');
                    $form.submit();
                }
            },
            maxTags() {
                this.$store.dispatch('notify', { msg: store.state.t.maxTags });
            },
            setTags(tags) {
                this.tags = tags.map(tag => tag.value);
            },
        }
    });
}

export default {
    stories,
    'stories-query': stories,
    'stories-queries': stories,
    'stories-edit': storiesForm,
    'stories-submit': storiesForm,
    'stories-view': () => {
        new Vue({ /* eslint no-new: 0 */
            el: '#stories-view-body',
            name: 'storiesView',
            store,
            components: {
                Comments,
                CompactUser
            },
            mixins: [PromptSignup],
            computed: {
                ...mapState({
                    gt: state => state.gt.common,
                    t: state => state.t.story_authorise
                })
            },
            data() {
                return {
                    hiddenAuthor: store.state.config.data.hiddenAuthor,
                    id: store.state.config.data.storyId,
                    showShare: navigator.share,
                    url: store.state.config.endpoints.stories
                };
            },
            directives: {
                dropdown: dropdownDirective
            },
            methods: {
                hideAuthor() {
                    const data = {
                        id: this.id,
                        hiddenAuthor: !this.hiddenAuthor,
                        url: this.url
                    };
                    ajax.update(this.url, data).then((response) => {
                        this.hiddenAuthor = !this.hiddenAuthor;
                        store.dispatch('notify', { msg: response.message });
                    }).catch(() => {
                        store.dispatch('notify', { msg: this.gt.error_alert, type: 'error' });
                    });
                },
                shareStory(title, text) {
                    navigator.share({
                        title,
                        text,
                        url: window.location.href
                    }).then(() => {
                        analytics('share', 'story');
                    }).catch(() => {});
                },
                approveStory(story) {
                    // Set the action
                    const msgData = {
                        storyId: story,
                        admin: 1,
                        subject: this.t.subject,
                        body: this.t.body,
                        action: 'approve'
                    };
                    ajax.create('authorizeStory', msgData).then(() => {
                        store.dispatch('notify', { msg: store.state.t.story_authorise.approve });
                        window.location.replace(store.state.config.data.router.storyAdmin);
                    }).catch(() => {
                        store.dispatch('notify', { msg: store.state.t.story_authorise.error_alert, type: 'error' });
                    });
                },
                rejectStory(story, user) {
                    const storyData = {
                        storyId: story,
                        action: 'reject',
                        noteId: ''
                    };
                    store.dispatch('sendAdminMessage', {
                        recipient: user.userName,
                        preset: 'Stories--2',
                        saveCallback({ noteId }) {
                            storyData.noteId = noteId;
                            ajax.create('authorizeStory', storyData).then(() => {
                                store.dispatch('notify', { msg: store.state.t.story_authorise.rejected });
                                window.location.replace(store.state.config.data.router.storyAdmin);
                            }).catch(() => {
                                store.dispatch('notify', { msg: store.state.t.story_authorise.error_alert, type: 'error' });
                            });
                        }
                    });
                },
                lockStory(story) {
                    const msgData = {
                        storyId: story,
                        action: 'lock'
                    };
                    ajax.create('authorizeStory', msgData).then(() => {
                        store.dispatch('notify', { msg: this.t.locked });
                        document.querySelector('#story-lock').remove();
                        window.location.reload();
                    }).catch(() => {
                        store.dispatch('notify', { msg: this.t.error_alert, type: 'error' });
                    });
                },
                deleteStory(story, user) {

                    const storyData = {
                        storyId: story,
                        action: 'delete'
                    };

                    // If we have a public submission, skip the message aspect
                    if (user === 0) {
                        ajax.create('authorizeStory', storyData).then(() => {
                            store.dispatch('notify', { msg: store.state.t.story_authorise.delete });
                            window.location.replace(store.state.config.data.router.storyAdmin);
                        }).catch(() => {
                            store.dispatch('notify', { msg: store.state.t.story_authorise.error_alert, type: 'error' });
                        });
                    } else {
                        store.dispatch('sendAdminMessage', {
                            recipient: user.userName,
                            preset: 'Stories--0',
                            saveCallback({ noteId }) {
                                storyData.noteId = noteId;
                                ajax.create('authorizeStory', storyData).then(() => {
                                    store.dispatch('notify', { msg: store.state.t.story_authorise.delete });
                                    window.location.replace(store.state.config.data.router.storyAdmin);
                                }).catch(() => {
                                    store.dispatch('notify', { msg: store.state.t.story_authorise.error_alert, type: 'error' });
                                });
                            }
                        });
                    }
                },
                userDeleteStory(id, redirect, text) {
                    store.dispatch('showConfirm', {
                        text,
                        callback() {
                            ajax.delete('stories', { id }).then(() => {
                                window.location = redirect;
                            });
                        }
                    });
                },
                deleteTag(tag) {
                    ajax.delete('story-tag', { id: tag }).then((response) => {
                        store.dispatch('notify', { msg: response.message });
                        document.querySelector(`#story-tag-${tag}`).remove();
                    });
                },
                removeTag(story, tag) {
                    ajax.update('stories', { removeTag: tag, id: story }).then((response) => {
                        store.dispatch('notify', { msg: response.message });
                        document.querySelector(`#story-tag-${tag}`).remove();
                    });
                }
            }
        });
    },
    ebooks() {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'ebooks',
            store,
            components: {
                Ebook,
                SiteInput,
                SiteSelect
            },
            data() {
                return {
                    sortOptions: [
                        { text: 'Author', value: 'author' },
                        { text: 'Title', value: 'title' }
                    ]
                };
            }
        });
    },
    'ebooks-admin': () => {
        new Vue({ /* eslint no-new: 0 */
            el: '#page-body',
            name: 'ebooks',
            store,
            components: {
                Ebook
            },
            methods: {
                approve(id) {
                    // Set the action
                    const msgData = {
                        ebookId: id,
                        action: 'approve'
                    };

                    ajax.create('authorizeEbook', msgData).then((response) => {
                        document.querySelector(`#ebook-${id}`).remove();
                        store.dispatch('notify', { msg: response.message });
                    });
                },
                reject(id, user) {
                    // Prompt the Mod to message the logged in user about the deletion
                    if (user !== 0) {
                        store.dispatch('sendAdminMessage', { recipient: user });
                    }

                    // Set the action
                    const msgData = {
                        ebookId: id,
                        action: 'delete'
                    };

                    ajax.create('authorizeEbook', msgData).then((response) => {
                        document.querySelector(`#ebook-${id}`).remove();
                        store.dispatch('notify', { msg: response.message });
                    });
                }
            }
        });
    }
};
